import http from './api'

const route = 'imagem/'

export default {
    showImagem: (idProduto, contratoId) => {
        return http.post(route + 'showImagem', {
            idProduto: idProduto,
            contratoId: contratoId,
        })
    },
}
